import { Provider, useSessionContext } from './Provider';

const Session = (props) => {
    return <Provider {...props}>
        {props.children}
    </Provider>
};

export default Session;

export {
    useSessionContext as useSession,
}